import { jsonMember, jsonObject } from 'typedjson';
import { PublicProductStatusType } from '../../enums/public-product-status-type';

@jsonObject
export class PublicProductVisibilityResponse {
  @jsonMember(String)
  public id!: string;

  @jsonMember(String)
  public status!: PublicProductStatusType;
}
